import { render, staticRenderFns } from "./invadobay-card-preview.vue?vue&type=template&id=24a99afc&scoped=true"
import script from "./invadobay-card-preview.vue?vue&type=script&lang=js"
export * from "./invadobay-card-preview.vue?vue&type=script&lang=js"
import style0 from "./invadobay-card-preview.vue?vue&type=style&index=0&id=24a99afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a99afc",
  null
  
)

export default component.exports